



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Menu extends Vue {
  @Prop({ default: true }) isDark!: boolean;
  private showMenu = false;
  private authUser = {};
  $toastr: any;

  toggleNavbar(): void {
    this.showMenu = !this.showMenu;
  }
}
